module.exports = __webpack_public_path__ + "static/Vikas@2-de4926cdbd0810c8dd135d687bf8ccc0.png";